import { parseFullName } from 'parse-full-name';

/**
 * Format the first and last name returning a full name object
 * @category Formatters
 * @category String
 */
export const nameParserWrapper = (nameToParse: string) => {
  const name = parseFullName(nameToParse);
  if (!name.first && name.last) {
    const splitedFakeLastName = name.last.split(' ');
    const realFirstName = splitedFakeLastName[0];
    name.first = realFirstName;

    splitedFakeLastName.shift();

    const realLastName = splitedFakeLastName.join(' ');
    name.last = realLastName;
  }

  return name;
};
